import React from 'react';
import { IndexRoute, Route } from 'react-router';
import ActionsHistory from './actionsHistory';

export default (
  <Route path="arquivadas">
    <IndexRoute component={props => <ActionsHistory {...props} />} />
  </Route>
);
